import { initLastCheckbox } from './sections/product-filter/last-clicked-checkbox';
import { initSimilarProductsCarousel } from './sections/product/product-carousel';
import { initClearFilter } from './sections/product-filter/clear-filter';

document.addEventListener('DOMContentLoaded', () => {
    initLastCheckbox('.filter-section');

    initClearFilter();

    initSimilarProductsCarousel();

    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        if (event.detail.snippet.id === 'snippet--activeFilters') {
            initClearFilter();
        }
    });
});
